/** The chip attributes that decide how a reference chip reads in sent text. */
export type FileChipMessageAttrs = {
  filename: string;
  uploadId: string;
  vfsPath?: string | null;
  semanticType?: string | null;
  typedPath?: string | null;
};

/**
 * A reference chip's form in a sent message: `[📎name](file:id)`, or, for a
 * chip that took the place of a path the user typed, that full path as
 * plain text, so CLI-style arguments keep their value (#4935).
 */
export function fileChipMessageText(attrs: FileChipMessageAttrs): string {
  if (attrs.typedPath) return attrs.typedPath;
  const chipTarget =
    attrs.semanticType === 'skill' && attrs.vfsPath
      ? `user-skill:${attrs.vfsPath}`
      : attrs.uploadId;
  return `[📎${attrs.filename}](file:${chipTarget})`;
}
